import { render, staticRenderFns } from "./FormColor.vue?vue&type=template&id=23794c9c&scoped=true"
import script from "./FormColor.vue?vue&type=script&lang=js"
export * from "./FormColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23794c9c",
  null
  
)

export default component.exports